// IconPicker.tsx
import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Grid,
    IconButton,
    Tooltip,
    Box,
} from '@mui/material';

// Uma lista curada de nomes de classes de ícones do Material Icons.
// A lista completa é enorme, mas esta cobre os casos mais comuns.
const materialIconClassNames = [
  'search', 'home', 'account_circle', 'settings', 'done', 'info', 'delete', 'visibility', 'favorite', 'logout', 'description', 'lock', 'schedule', 'language', 'help_outline', 'manage_accounts', 'filter_alt', 'event', 'verified', 'thumb_up', 'cloud_upload', 'add', 'remove', 'close', 'edit', 'menu', 'pets', 'directions_car', 'agriculture', 'apartment', 'desktop_windows', 'shopping_cart', 'attach_money', 'bar_chart', 'build', 'calendar_today', 'camera_alt', 'chat', 'circle_notifications', 'contact_support', 'dashboard', 'email', 'folder', 'groups', 'history', 'lightbulb', 'list', 'location_on', 'map', 'paid', 'people', 'person', 'phone', 'photo', 'print', 'receipt', 'refresh', 'save', 'share', 'star', 'store', 'sync', 'task_alt', 'toc', 'trending_up', 'work', 'warning'
];


interface IconPickerProps {
    open: boolean;
    onClose: () => void;
    onSelect: (iconClassName: string) => void;
}

export const IconPicker: React.FC<IconPickerProps> = ({ open, onClose, onSelect }) => {
    const [filter, setFilter] = React.useState('');

    const filteredIcons = materialIconClassNames.filter((name) =>
        name.toLowerCase().includes(filter.toLowerCase())
    );

    const handleSelectIcon = (iconClassName: string) => {
        onSelect(iconClassName);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Biblioteca de Ícones</DialogTitle>
            <DialogContent dividers>
                <TextField
                    fullWidth
                    label="Buscar ícone (ex: 'person', 'delete', 'settings')"
                    variant="outlined"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    sx={{ mb: 2, position: 'sticky', top: 0, zIndex: 1, backgroundColor: 'background.paper' }}
                />
                <Grid container spacing={1}>
                    {filteredIcons.map((iconName) => (
                        <Grid item key={iconName}>
                            <Tooltip title={iconName}>
                                <IconButton onClick={() => handleSelectIcon(iconName)}>
                                    {/* Renderiza o ícone usando a tag e classe CSS padrão do Google */}
                                    <span className="material-icons-outlined">{iconName}</span>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
        </Dialog>
    );
};